import { render, staticRenderFns } from "./CredentialConfig.vue?vue&type=template&id=0a6d554c&"
import script from "./CredentialConfig.vue?vue&type=script&lang=ts&"
export * from "./CredentialConfig.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialConfig.vue?vue&type=style&index=0&id=0a6d554c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports